import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  AfterViewInit,
  Renderer2,
} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'img[backgroundImage], mb-carousel[backgroundImage]',
  standalone: true,
})
export class BackgroundImageDirective implements AfterViewInit {
  @Input() brand: string;

  private readonly DEFAULT_IMAGE_AVANTRIP =
    '/hotels/results/dist/es-AR/browser/assets/images/avantrip-hotel-no-image.svg';
  private readonly DEFAULT_IMAGE_ALMUNDO =
    '/hotels/results/dist/es-AR/browser/assets/images/almundo-hotel-no-image.svg';

  constructor(private elRef: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    const tag = this.elRef.nativeElement.tagName.toLowerCase();

    if (tag === 'mb-carousel') {
      this.applyFallbackToCarousel();
    }
  }

  @HostListener('error')
  onImageError(): void {
    const element = this.elRef.nativeElement as HTMLImageElement;
    element.src = this.getDefaultImage();
    this.renderer.addClass(element, 'has-fallback-bg');
  }

  private applyFallbackToCarousel(): void {
    const el = this.elRef.nativeElement as HTMLElement;

    const applyFallback = () => {
      const imgs = el.querySelectorAll('img');
      imgs.forEach((img: HTMLImageElement) => {
        img.onerror = () => {
          img.src = this.getDefaultImage();
          this.renderer.addClass(img, 'has-fallback-bg');
        };
      });
    };
    applyFallback();

    const observer = new MutationObserver(() => applyFallback());
    observer.observe(el, { childList: true, subtree: true });
  }

  private getDefaultImage(): string {
    return this.brand === 'avantrip' ? this.DEFAULT_IMAGE_AVANTRIP : this.DEFAULT_IMAGE_ALMUNDO;
  }
}
